<template>
    <div class="col-12 mt-1">
        <div class="form-group row m-b-xs">
            <div class="col max-w-20">
                <label>{{ __('lp') }}</label><br>
                <span class="product-lp">{{ humanIndex }}</span>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.name`)}" class="col p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.name`)"
                    :readonly="symbolFieldsReadonly"
                    :label="__('good_or_service_name')"
                    :required="isRequired('items.name')"
                    :value="item.name"
                    classNames="form-control"
                    @input="emitInput('name', $event)"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.quantity`)}"
                 class="col text-right max-w-80 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.quantity`)"
                    :label="__('item_quantity')"
                    :required="isRequired('items.quantity')"
                    :value="item.quantity | money"
                    classNames="form-control text-right"
                    mask="quantity"
                    @input="emitInput('quantity', parseFloat($event))"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.unit`)}" class="col  max-w-80 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.unit`)"
                    :label="__('unit_of_mesure')"
                    :readonly="symbolFieldsReadonly"
                    :required="isRequired('items.unit')"
                    :value="item.unit"
                    classNames="form-control"
                    @input="emitInput('unit', $event)"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.price`)}"
                 class="col text-right max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="hasDiscount || disabled"
                    :errors="getErrors(`items.${itemIndex}.price`)"
                    :label="__('price')"
                    :required="isRequiredPrice"
                    :value="item.price | money"
                    classNames="form-control text-right"
                    mask="money"
                    @input="emitInput('price', parseFloat($event))"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.gross_amount`)}"
                 class="col text-right max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.gross_amount`)"
                    :label="__('value')"
                    :required="isRequired('items.gross_amount')"
                    :value="item.gross_amount | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.margin`)}"
                 class="col text-right max-w-120 p-l-5 p-r-5 white-space-no-wrap">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.margin`)"
                    :label="__('margin_amount_included_short')"
                    :required="isRequired('items.margin')"
                    :value="item.margin | money"
                    classNames="form-control text-right"
                    mask="money"
                    @input="emitInput('margin', parseFloat($event))"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.margin_vat_rate`)}"
                 class="max-w-130 col  p-l-5 p-r-5 white-space-no-wrap">
                <label>{{ __('margin_vat_rate_id_short') }}{{ isRequiredDesignation('items.margin_vat_rate') }}</label>
                <select2
                    :disabled="disabled"
                    :options="vatRateOptions"
                    :value="item.margin_vat_rate"
                    @input="emitInput('margin_vat_rate', parseInt($event))"
                    :settings="{dropdownCssClass: 'drop-lg'}"
                />

                <InputErrors :errors="getErrors(`items.${itemIndex}.vat_rate`)"/>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.margin_vat_amount`)}"
                 class="max-w-120 col text-right  p-l-5 p-r-5 white-space-no-wrap">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.margin_vat_amount`)"
                    :label="__('item_margin_vat_amount_short')"
                    :required="isRequired('items.margin_vat_amount')"
                    :value="item.margin_vat_amount | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div class="col-md-auto table-icons" style="width: 45px">
                <label class="m-b"> </label><br>
                <a v-if="canDeleteItem && !disabled"
                   :data-original-title="__('delete')"
                   data-placement="top"
                   data-toggle="tooltip"
                   @click="removeRow">
                    <i class="fa fa-trash"></i>
                </a>
            </div>
        </div>

        <div class="form-group row m-b">
            <div class="col max-w-20"></div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.symbol`)}" class="max-w-120 col  p-r-5">
                <label>{{ __('symbol') }}{{ isRequiredDesignation('items.symbol') }}</label>
                <select2
                    :disabled="disabled"
                    :options="standardItemsOptions"
                    v-model="selectedStandardItem"
                    @change="changeSymbolFields()"
                    @input="emitInput('standard_item_id', $event)"
                    :settings="standardItemSettings"
                />
            </div>
            <div class="col max-w-30 mt-4" v-if="!disabled && getPermission('create_standard_item')">
                <button style="position: absolute;left: -8px;top: -7px" type="button" :data-original-title="__('add_goods_services')"  @click="addStandardItem(itemIndex)" class="add-standard-item-button btn btn-primary btn-sm m-l-xs tooltip-more"><i class="fa fa-plus"></i></button>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.pkwiu`)}" class="col max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.pkwiu`)"
                    :label="__('pkwiu')"
                    :required="isRequired('items.pkwiu')"
                    :value="item.pkwiu"
                    classNames="form-control"
                    @input="emitInput('pkwiu', $event)"
                />
            </div>
            <div v-if="additionalFields.includes('gtin')" :class="{'has-error': hasError(`items.${itemIndex}.gtin`)}" class="col max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.gtin`)"
                    :label="__('gtin')"
                    labelClass="white-space-no-wrap"
                    :required="isRequired('items.gtin')"
                    :value="item.gtin"
                    classNames="form-control"
                    @input="emitInput('gtin', $event)"
                />
            </div>
            <div v-if="additionalFields.includes('cn')" :class="{'has-error': hasError(`items.${itemIndex}.cn`)}" class="col max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.cn`)"
                    :label="__('cn')"
                    labelClass="white-space-no-wrap"
                    :required="isRequired('items.cn')"
                    :value="item.cn"
                    classNames="form-control"
                    @input="emitInput('cn', $event)"
                />
            </div>
            <div v-if="additionalFields.includes('pkob')" :class="{'has-error': hasError(`items.${itemIndex}.pkob`)}" class="col max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.pkob`)"
                    :label="__('pkob')"
                    labelClass="white-space-no-wrap"
                    :required="isRequired('items.pkob')"
                    :value="item.pkob"
                    classNames="form-control"
                    @input="emitInput('pkob', $event)"
                />
            </div>

            <div v-if="additionalFields.includes('excise_tax_amount')" :class="{'has-error': hasError(`items.${itemIndex}.excise_tax_amount`)}" class="col max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.excise_tax_amount`)"
                    :label="__('excise_tax_amount_short')"
                    labelClass="white-space-no-wrap"
                    :required="isRequired('items.excise_tax_amount')"
                    :value="item.excise_tax_amount | money"
                    classNames="form-control text-right"
                    mask="money"
                    @input="emitInput('excise_tax_amount', parseFloat($event))"
                />
            </div>
            <div v-if="additionalFields.includes('gtu')" :class="{'has-error': hasError(`items.${itemIndex}.gtu`)}" class="max-w-120 col p-l-5 p-r-5">
                <label>{{ __('gtu') }}{{ isRequiredDesignation('items.gtu') }}</label>
                <select2
                    :disabled="disabled"
                    :options="gtuOptions"
                    :value="item.gtu"
                    @input="emitInput('gtu', $event)"
                    :settings="gtuSettings"
                />

                <InputErrors :errors="getErrors(`items.${itemIndex}.gtu`)"/>
            </div>
            <div v-if="additionalFields.includes('procedure')" :class="{'has-error': hasError(`items.${itemIndex}.procedure`)}" class="max-w-120 col p-l-5 p-r-5">
                <label>{{ __('procedure') }}{{ isRequiredDesignation('items.procedure') }}</label>
                <select2
                    :disabled="disabled"
                    :options="procedureOptions"
                    :value="item.procedure"
                    @input="emitInput('procedure', $event)"
                    :settings="procedureSettings"
                />

                <InputErrors :errors="getErrors(`items.${itemIndex}.procedure`)"/>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.description`)}" class="col p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.description`)"
                    :label="__('goods_or_service_description_short')"
                    labelClass="white-space-no-wrap"
                    :required="isRequired('items.description')"
                    :value="item.description"
                    classNames="form-control"
                    @input="emitInput('description', $event)"
                />
            </div>

            <div class="col max-w-max-content text-right p-l-0 p-r-5 mt-4">
                <label>
                    <input
                        :checked="item.has_discount"
                        :disabled="disabled"
                        type="checkbox"
                        @change="discountChange($event.target.checked)"
                    > {{ __('add_discount') }}
                </label>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.price_before_discount`)}"
                 class="col text-right max-w-120 p-l-5 p-r-5 white-space-no-wrap">
                <InputWrapper
                    :disabled="!hasDiscount || disabled"
                    :errors="getErrors(`items.${itemIndex}.price_before_discount`)"
                    :label="__('price_before_discount')"
                    :required="isRequiredPriceBeforeDiscount"
                    :value="item.price_before_discount | money"
                    classNames="form-control text-right"
                    mask="money"
                    @input="emitInput('price_before_discount', parseFloat($event))"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.discount`)}"
                 class="col text-right max-w-120 p-l-5 p-r-5 m-r-45">
                <InputWrapper
                    :disabled="!hasDiscount || disabled"
                    :errors="getErrors(`items.${itemIndex}.discount`)"
                    :label="__('discount%')"
                    :required="isRequiredDiscount"
                    :value="item.discount | money"
                    classNames="form-control text-right"
                    mask="percentages"
                    @input="emitInput('discount', parseFloat($event))"
                />
            </div>

            <div style="width: 45px"></div>
        </div>
    </div>
</template>

<script>
import inputEmit from "../../../../mixins/inputEmit";
import hasErrors from "../../../../mixins/hasErrors";
import hasTooltips from "../../../../mixins/hasTooltips";
import InputWrapper from "../../../form/InputWrapper";
import InputErrors from "../../../form/InputErrors";
import hasRequiredFields from "../../../../mixins/hasRequiredFields";
import hasPermissions from "../../../../mixins/hasPermissions";
import {round} from "lodash";

export default {
    name: "MarginItemRow",
    components: {InputErrors, InputWrapper},
    mixins: [inputEmit, hasErrors, hasTooltips, hasRequiredFields, hasPermissions],
    data() {
        return {
            symbolFieldsReadonly: false,
            selectedStandardItem: this.standardItemId
        };
    },
    props: {
        standardItems: {
            type: Array,
            default: [],
        },
        standardItemId: {
            type: Number,
            default: 0,
        },
        item: {
            type: Object,
            required: true,
        },
        itemIndex: {
            type: Number,
            required: true,
        },
        vatRates: {
            type: Array,
            default: [],
        },
        canDeleteItem: {
            type: Boolean,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        additionalFields: {
            type: Array,
            default: () => [],
        },
        gtus: {
            type: Array,
            default: () => [],
        },
        procedures: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        addStandardItem(parentDiv){
            this.$emit('addStandardItem', parentDiv)
        },
        changeSymbolFields(){
            const _this = this;
            if(this.selectedStandardItem != 0){
                let standardItemIndex = this.standardItems.findIndex(function (item){
                    return item.id == _this.selectedStandardItem;
                })
                this.item.name = this.standardItems[standardItemIndex].item_name
                this.item.unit = this.standardItems[standardItemIndex].item_unit_of_measure
                this.item.gtin = this.standardItems[standardItemIndex].gtin
                this.item.cn = this.standardItems[standardItemIndex].cn
                this.item.pkob = this.standardItems[standardItemIndex].pkob
                this.item.gtu = this.standardItems[standardItemIndex].gtu ?? 0
                if(this.standardItems[standardItemIndex].classification !== null){
                    this.item.pkwiu = this.standardItems[standardItemIndex].classification
                }
                else{
                    this.item.pkwiu = '';
                }
                if(this.standardItems[standardItemIndex].description !== null){
                    this.item.description = this.standardItems[standardItemIndex].description
                }
                else{
                    this.item.description = '';
                }
                this.symbolFieldsReadonly = true;
            }
            else{
                this.item.name = ''
                this.item.unit = ''
                this.item.pkwiu = ''
                this.item.gtin = ''
                this.item.cn = ''
                this.item.pkob = ''
                this.item.description = ''
                this.item.gtu = "0";
                this.symbolFieldsReadonly = false;
            }
        },
        removeRow() {
            this.$emit('removeItem');
            this.clearTooltips();
        },
        updateItemValues() {
            this.emitInput('gross_amount', this.itemGrossAmount);
            this.emitInput('net_amount', this.itemGrossAmount);
            this.emitInput('margin', this.itemMarginAmount);
            this.emitInput('excise_tax_amount', this.itemExciseTaxAmount);
            this.emitInput('margin_vat_amount', this.itemMarginVatAmount);
            this.$emit('itemChanged');
        },
        updateItemDiscountPrice() {
            this.emitInput('price', this.itemDiscountedPrice);
        },
        discountChange(checked) {
            this.emitInput('has_discount', checked);
            if (!checked) {
                this.emitInput('price_before_discount', 0);
                this.emitInput('discount', 0);
            }
        },
    },
    computed: {
        standardItemSettings() {
            return {
                templateResult: (option) => {
                    let standardItem = this.standardItems.find(c => c.symbol == option.text);
                    if(standardItem == undefined){
                        return option.text;
                    }
                    if(['not_active'].includes(standardItem.status)){
                        return null;
                    }
                    return standardItem.symbol + ": " + standardItem.item_name;
                },
                dropdownCssClass: 'drop-128'
            };
        },
        gtuSettings() {
            return {
                templateResult: (option) => {
                    let gtu = this.gtus.find(c => c.text == option.text);
                    if(gtu == undefined){
                        return option.text;
                    }
                    if(gtu.draft){
                        return gtu.text + "[" + gtu.draft + "]";
                    }
                    else{
                        return gtu.text
                    }

                },
                dropdownCssClass: 'drop-128 center-dropdown',
                tags:true
            };
        },
        procedureSettings() {
            return {
                templateResult: (option) => {
                    let gtu = this.procedures.find(c => c.text == option.text);
                    if(gtu == undefined){
                        return option.text;                    }
                    return gtu.text;
                },
                dropdownCssClass: 'drop-128 center-dropdown',
                tags:true
            };
        },
        gtuOptions() {
            let gtus = this.gtus;
            let options = gtus.map(option => ({text: option.text,id: option.text}));
            options.unshift({text: '---', id: 0});
            return options;
        },
        procedureOptions() {
            let procedures = this.procedures;
            let options = procedures.map(option => ({text: option.text,id: option.text}));
            options.unshift({text: '---', id: 0});
            return options;
        },
        standardItemsOptions() {
            let standardItems = this.standardItems;
            let options = standardItems.map(option => ({text: option.symbol,  id: option.id}));
            options.unshift({text: '---', id: 0});

            return options;
        },
        isRequiredPriceBeforeDiscount() {
            return this.hasDiscount && this.isRequired('items.price_before_discount');
        },
        isRequiredDiscount() {
            return this.hasDiscount && this.isRequired('items.discount');
        },
        isRequiredPrice() {
            return !this.hasDiscount && this.isRequired('items.price');
        },
        vatRateOptions() {
            return this.vatRates.map(option => ({text: option.country_iso + ": " + option.label, id: option.id}));
        },
        hasDiscount() {
            return this.item.has_discount;
        },
        humanIndex() {
            return this.itemIndex + 1;
        },
        valuesToObserveChange() {
            return [
                this.item.quantity,
                this.item.price,
                this.item.margin,
                this.item.margin_vat_rate,
                this.item.excise_tax_amount,
            ];
        },
        discountInputs() {
            return [
                this.item.price_before_discount,
                this.item.discount,
            ];
        },
        itemGrossAmount() {
            const amount = this.item.quantity * this.item.price || 0;

            return round(round(amount, 10), 2);
        },
        itemMarginAmount() {
            let amount = this.item.margin;

            if (amount > this.itemGrossAmount) {
                amount = this.itemGrossAmount;
            }

            return round(round(amount, 10), 2);
        },
        itemExciseTaxAmount(){
            let amount = this.item.excise_tax_amount;

            if (amount > this.itemGrossAmount) {
                amount = this.itemGrossAmount;
            }
            if(typeof amount == 'number'){
                return parseFloat(amount.toFixed(2));
            }
            else{
                return amount
            }

        },
        itemMarginVatAmount() {
            const amount = (this.itemMarginAmount * this.selectedVatRateRate) / (1 + this.selectedVatRateRate);

            return round(round(amount, 10), 2);
        },
        itemDiscountedPrice() {
            return round(round(this.item.price_before_discount * (1 - this.item.discount / 100), 10), 2);
        },
        selectedVatRate() {
            return this.vatRates.find(vr => vr.id === parseInt(this.item.margin_vat_rate)) || {};
        },
        selectedVatRateRate() {
            return (parseFloat(this.selectedVatRate.rate) / 100);
        },
    },
    watch: {
        valuesToObserveChange: {
            deep: true,
            handler() {
                this.updateItemValues();
            },
        },
        discountInputs: {
            deep: true,
            handler() {
                if (this.hasDiscount) {
                    this.updateItemDiscountPrice();
                }
            },
        },
    },
    mounted() {
        const _this = this;
        let standardItemIndexByItemName = this.standardItems.findIndex(function(item){
            return item.id == _this.item.standard_item_id;
        })
        if(standardItemIndexByItemName >= 0){
            this.selectedStandardItem = this.standardItems[standardItemIndexByItemName].id
            this.symbolFieldsReadonly = true;
            this.changeSymbolFields()
        }
    }
};
</script>
